import { SmartComponentPropertyDetails } from "../smart-components/smart-component-property-details";
import { IComponentLoader } from "../../interfaces/IComponentLoader";
import { ComponentAdapterParent } from "./component-adapter-parent";
import { SkillNameList } from "../../enum/enumSkillNameList";
import { AddressDetails } from "../smart-components/smart-component-property";

/**
 * This class handle properties of alarm
 */
export class ComponentAdaperAlarm extends ComponentAdapterParent implements IComponentLoader {
    private _alarmState: AddressDetails = null;
    private _alarmReset: AddressDetails = null;
    private _inverted: boolean = null;

    /**
     * Get the alarm state address
     */
    get AlarmState(): AddressDetails {
        return this._alarmState;
    }

    /**
 * Get the alarm Reset address
 */
    get AlarmReset(): AddressDetails {
        return this._alarmReset;
    }

    /**
     * Get the alarm inverted
     */
    get Inverted(): boolean {
        return this._inverted;
    }

    constructor () {
        super();
    }

    public fillProperty(listSmartComponentSkills: Array<SmartComponentPropertyDetails>): void {
        this._name = listSmartComponentSkills.find(titleSkill => titleSkill.titleSkill === SkillNameList.ALARM_NAME)?.value || "";
        this._description = listSmartComponentSkills.find(titleSkill => titleSkill.titleSkill === SkillNameList.ALARM_DESCRIPTION)?.value || "";
        this._alarmState = listSmartComponentSkills.find(titleSkill => titleSkill.titleSkill === SkillNameList.ALARM_STATE)?.address || null;
        this._alarmReset = listSmartComponentSkills.find(titleSkill => titleSkill.titleSkill === SkillNameList.ALARM_RESET)?.address || null;
        this._inverted = listSmartComponentSkills.find(titleSkill => titleSkill.titleSkill === SkillNameList.ALARM_INVERTED)?.value === "1" || false;

        this.fillMissingProperty();
        this.fillAddressState();
    }

    public fillMissingProperty(): void {
    }

    public fillAddressState(): void {
        if (this._alarmState) {
            this._listSubscribeAddress.push(this._alarmState);
        }
        if (this._alarmReset) {
            this._listSubscribeAddress.push(this._alarmReset);
        }

    }
}